import * as CONST from '../ActionTypes';

const initialState = {
  transactionStatusCsvList: [],
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    idFrom: '',
    idTo: '',
    amountFrom: '',
    amountTo: '',
    refundAmountFrom: '',
    refundAmountTo: '',
    transactionStatus: '',
    csvType: '',
    orderId: '',
    latestStatus: false,
  },
  count: 0,
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function transactionStatusCsv(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 決済履歴一覧取得
    // -----------------
    case CONST.GET_TRANSACTION_STATUS_CSV_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          transactionStatusCsvList: action.payload,
        },
      );
    case CONST.GET_TRANSACTION_STATUS_CSV_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          transactionStatusCsvList: [],
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_TRANSACTION_STATUS_CSV_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );
    // -----------------
    // queryパラメータのクリア
    // -----------------
    case CONST.CLEAR_TRANSACTION_QUERY:
      return Object.assign(
        {},
        state,
        {
          searchParams: {
            idFrom: '',
            idTo: '',
            amountFrom: '',
            amountTo: '',
            refundAmountFrom: '',
            refundAmountTo: '',
            orderId: '',
            transactionStatus: '',
            csvType: '',
            latestStatus: false,
          },
          sortParams: {
            createdAtAsc: false,
            idAsc: true,
            amountAsc: true,
          },
        },
      );
    // -----------------
    // CSVインポート
    // -----------------
    case CONST.UPLOAD_CSV_TRANSACTION_STATUS_VERITRANS_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.UPLOAD_CSV_TRANSACTION_STATUS_VERITRANS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default transactionStatusCsv;
